module.exports = __webpack_public_path__ + "img/1497808783.1eaf5e00.jpg";